<template>
    <svg v-tooltip="{content: 'Reset filters', placement: 'top', triggers: ['click','hover']}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="refresh">
            <path id="Icon / Refresh (Stroke)" fill-rule="evenodd" clip-rule="evenodd"
                d="M3.923 2.0008C4.27339 2.0035 4.55053 2.27748 4.55053 2.62156V2.62476L4.51087 4.6472C5.3928 3.96356 6.57749 3.44315 7.9843 3.44315C11.2827 3.44315 13.4838 6.16154 13.5 8.72054L13.5 8.72158C13.5 11.2663 11.2985 14 8 14C6.45662 14 5.02766 13.3775 3.97459 12.2612C3.0521 11.2855 2.5 9.95337 2.5 8.72158C2.5 8.372 2.7838 8.1008 3.14844 8.1008C3.51309 8.1008 3.79689 8.372 3.79689 8.72158C3.79689 11.3529 6.2336 12.7584 8 12.7584C10.0344 12.7584 12.2031 11.125 12.2031 8.72158C12.2031 6.77457 10.5114 4.69974 8 4.69974C6.96857 4.69974 6.08119 5.08309 5.41003 5.58317L7.50697 5.54669C7.88895 5.52813 8.17469 5.79903 8.1774 6.14737C8.196 6.49632 7.91421 6.78731 7.54629 6.78816L3.87371 6.84824L3.87068 6.84826C3.6825 6.84826 3.52747 6.7854 3.39991 6.66333C3.27022 6.53923 3.20654 6.3748 3.20654 6.21246V6.20962L3.26934 2.605C3.27021 2.27846 3.5477 1.98253 3.923 2.0008Z"
                :fill="fill" />
        </g>
    </svg>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props:{
        fill:{
            default: '#667488',
        }
    }
}
</script>
